module.exports = __webpack_public_path__ + "img/checklist.c31bfbcc.svg";